module.exports = __webpack_public_path__ + "img/sv81.1becf1b5.svg";